import React from 'react';


const VtrgEditPanel = ({hideUpdatePanel, ordn, RetweetVtrgPiece, DestroyVtrgPiece, UpdateVtrgPiece , position}) => {
    return (
      <div className={`vtrg-edit-control ${position} ${hideUpdatePanel === ordn ? 'hide' : ''}`}>
        <button
          className="btn vtrg-edit-control-move"
          title="Переместить"
          onClick={RetweetVtrgPiece}
        >
          <span className="icon icon--ei-retweet icon--m "></span>
        </button>
        <button
          className="btn vtrg-edit-control-edit"
          title="Редактировать"
          // onClick={UpdateVtrgPiece}
          onClick={(ev) => {  
            UpdateVtrgPiece(ordn);
            // refreshContentRetweet();
          }}
        >
          <span className="icon icon--ei-pencil icon--m "></span>
        </button>
        <button
          className="btn vtrg-edit-control-destroy"
          title="Удалить"
          onClick={DestroyVtrgPiece}
        >
          <span className="icon icon--ei-trash icon--m "></span>
        </button>
      </div>
    )
}

export default VtrgEditPanel;
